module.exports = __webpack_public_path__ + "img/corner-down-right.b0e1d493.svg";